module.exports = __webpack_public_path__ + "static/img_2582-6988c94611893e680358c02cfaefe114.webp";